<template>
  <div>
    <v-layout
      align-center
      justify-space-between>
      <span class="headline">
        Site configuration items
      </span>
      <v-btn
        color="green darken-2"
        class="ma-0"
        @click="add">
        New item
      </v-btn>
    </v-layout>

    <v-container>

      <template v-if="loading">
        <v-layout
          class="mt-5"
          justify-center>
          <v-progress-circular
            size="50"
            indeterminate/>
        </v-layout>
      </template>

      <template v-else-if="items.length === 0">
        <v-layout
          class="mt-5"
          justify-center>
          <span class="title">No item.</span>
        </v-layout>
      </template>

      <template v-else>
        <v-progress-linear
          v-if="deleting"
          class="ma-0"
          color="grey"
          height="1"
          indeterminate/>
        <v-divider v-else/>
        <v-data-table
          v-if="items.length > 0"
          :headers="headers"
          :items="items"
          hide-actions>
          <template
            slot="items"
            slot-scope="props">
            <tr>
              <td>
                {{ props.item.name }}
              </td>
              <td class="justify-center layout px-0">
                <v-btn
                  icon
                  class="mx-0"
                  @click="edit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="mx-0"
                  @click="del(props.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>

    </v-container>

    <new-dialog
      v-model="newDialog"
      @refresh="getItems"/>

    <edit-dialog
      v-model="editDialog"
      :item="editedItem"
      @refresh="getItems"/>

  </div>
</template>

<script>
import EditDialog from "./SiteConfItems/EditDialog.vue";
import NewDialog from "./SiteConfItems/NewDialog.vue";

export default {
  components: {
    EditDialog,
    NewDialog
  },
  data () {
    return {
      deleting: false,
      editDialog: false,
      editedItem: {
        id: 0,
        name: ""
      },
      headers: [
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          width: "10%"
        }
      ],
      /*
       * Index of the currently edited item in the array `items`
       * `index` is -1 when a new item is added or edition mode is off
       */
      index: -1,
      // Array containing all the items, populated in `created`
      items: [],
      loading: false,
      newDialog: false,
      posting: false,
      valid: false
    };
  },
  created () {
    this.getItems();
  },
  methods: {
    add () {
      this.editedItem.name = "";
      this.newDialog = true;
    },
    edit (item) {
      this.editedItem.id = item.id;
      this.editedItem.name = item.name;
      this.editDialog = true;
    },
    del (item) {
      if (confirm("Are you sure you want to delete this item?")) {
        this.deleting = true;
        this.$http.
          delete(`/api/site_configuration_items/${item.id}`).
          then(() => this.getItems()).
          finally(() => this.deleting = false);
      }
    },
    getItems () {
      // Get the items
      this.loading = true;
      this.$http.
        get("/api/site_configuration_items").
        then((r) => this.items = Array.from(r.data)).
        finally(() => this.loading = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/SiteConfItems.vue